import { render, staticRenderFns } from "./CalculateYourTaxes.vue?vue&type=template&id=b9c0d298&lang=pug"
import script from "./CalculateYourTaxes.vue?vue&type=script&lang=ts"
export * from "./CalculateYourTaxes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports